module.exports = __webpack_public_path__ + "static/house-645f47e042cd1831a9f2dffa5473b764.jpg";